// extracted by mini-css-extract-plugin
export default {"ring_sm":"LoadingSpinner_ring_sm__aWpkc","ring":"LoadingSpinner_ring__BkpjL","ring_md":"LoadingSpinner_ring_md__17r0I","ring_lg":"LoadingSpinner_ring_lg__oTlOH"};